import PageTitle, { PageTitleProps } from "@app/components/page-title.tsx";
import { UseQueryResult } from "@tanstack/react-query";
import { QueryStatusRouter } from "bi-lib";
import { PropsWithChildren, useMemo } from "react";

interface Props extends PageTitleProps {
    title: string;
    hideTitle?: boolean;
    queryHook?: UseQueryResult | UseQueryResult[];
}

export function PageContainer({ children, title, hideTitle = false, queryHook, from }: PropsWithChildren<Props>) {
    const childComponents = useMemo(
        () =>
            queryHook == undefined ? children : <QueryStatusRouter queryHook={queryHook}>{children}</QueryStatusRouter>,
        [queryHook, children],
    );

    return (
        <>
            {!hideTitle && <PageTitle from={from}>{title}</PageTitle>}
            {childComponents}
        </>
    );
}
